import React from 'react';
import './ErrorFallback.css';

function ErrorFallback({ error, resetError, eventId }) {
  const reload = () => { window.location.reload(); };

  return (
    <div className="errfb-root">
      <div className="errfb-card">
        <div className="errfb-kicker">Crash detected</div>
        <h1 className="errfb-title">The coach took a hit.</h1>
        <p className="errfb-sub">
          Something broke while rendering this page. The error has been reported — I'll take a look.
          Try reloading, or head back to the team list.
        </p>

        {eventId && (
          <div className="errfb-eventid">
            Reference: <code>{eventId}</code>
          </div>
        )}

        {error?.message && (
          <details className="errfb-details">
            <summary>Technical details</summary>
            <pre>{String(error.message)}</pre>
          </details>
        )}

        <div className="errfb-actions">
          <button className="errfb-btn ghost" onClick={resetError}>
            Try again
          </button>
          <button className="errfb-btn primary" onClick={reload}>
            Reload page
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorFallback;
